import { render, staticRenderFns } from "./view-goals.vue?vue&type=template&id=355c8340&scoped=true&"
import script from "./view-goals.vue?vue&type=script&lang=js&"
export * from "./view-goals.vue?vue&type=script&lang=js&"
import style0 from "./view-goals.vue?vue&type=style&index=0&id=355c8340&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "355c8340",
  null
  
)

export default component.exports